import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/features/group-shopping/components/GroupShopping.tsx");
